import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ConfigService } from './../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class VentabonosService {
  headers: HttpHeaders = new HttpHeaders({
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(
    private httpClient: HttpClient,
    private config: ConfigService
  ) { }

  async getPrestadores(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/ComprarBono/ObtenerPrestadores`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getLugaresAtencion(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/ComprarBono/BuscarLugaresAtencion`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getRegiones() {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/Regiones/GetRegiones`;

    try {
      return await this.httpClient.get(url).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getComunas(codRegion) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/Regiones/GetComunasRegion?codRegion=${codRegion}`;

    try {
      return await this.httpClient.get(url).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async valorizarBono(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/ComprarBono/ValorizarBono`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async emitirBono(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/ComprarBono/EmitirBonoVentaWeb`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async registrarBono(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/ComprarBono/RegistrarPago`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async obtenerBono(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/ComprarBono/ObtenerBonoB64`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async consultarBono(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/ComprarBono/ConsultarBonoRut`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

   async getExcedentes(marca: string) {
    const rut = localStorage.getItem('cbRutCliente');
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/ComprarBono/ObtenerExcedentes`;
    const data = { rutCotizante: Number(rut), marca }
  
    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }
}
